import styled from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';

export const LogoWrapper = styled(Box)`
  line-height: 0;
`;

LogoWrapper.displayName = 'LogoWrapper';
